import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { useInView } from '../hooks/useInView';
interface ProtocoloSectionProps {
  handlePurchase: () => void;
}
export function ProtocoloSection({
  handlePurchase
}: ProtocoloSectionProps) {
  const includes = ['Manual Maestro de Abundancia (PDF Alta Resolución)', 'Audio de Frecuencia 888Hz (MP3 Alta Fidelidad)', 'Guía de Activación de 21 Días', 'Protocolo de Reprogramación Nocturna', 'Acceso Inmediato y de Por Vida', 'Actualizaciones 2026 Incluidas'];
  const [leftRef, leftInView] = useInView();
  const [rightRef, rightInView] = useInView();
  const [bgRef, bgInView] = useInView({
    rootMargin: '200px'
  });
  return <section ref={bgRef} id="protocolo" aria-label="El protocolo completo - contenido y precio" className="relative py-16 sm:py-24 px-4 sm:px-[5%] border-t border-white/5 bg-cover bg-center" style={{
    backgroundImage: bgInView ? "url('https://cdn.shopify.com/s/files/1/0981/0781/8286/files/Simbolo_dorado_infinito_en_el_vacio.png?v=1775971771')" : 'none'
  }} data-id="element-139">
      {/* Overlays - same effect as CienciaSection */}
      <div className="absolute inset-0 z-[1]" aria-hidden="true" style={{
      background: 'linear-gradient(180deg, #0A0A0B 5%, rgba(10,10,11,0.4) 50%, #0A0A0B 95%)'
    }} data-id="element-140" />
      <div className="absolute inset-0 hidden lg:block z-[1]" aria-hidden="true" style={{
      background: 'linear-gradient(90deg, #0A0A0B 10%, transparent 55%, #0A0A0B 90%)'
    }} data-id="element-141" />

      <div className="max-w-[1000px] mx-auto relative z-[2]" data-id="element-142">
        <div className="bg-dark/70 backdrop-blur-sm border border-gold/30 rounded-2xl p-6 sm:p-8 md:p-12 shadow-[0_0_50px_rgba(212,175,55,0.1)]" data-id="element-143">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-144">
            <div ref={leftRef} className={`will-animate animate-slideLeft ${leftInView ? 'is-visible' : ''}`} data-id="element-145">
              <h2 className="font-serif text-3xl md:text-4xl font-black mb-6" data-id="element-146">
                EL PROTOCOLO <br data-id="element-147" />
                <span className="text-gold" data-id="element-148">COMPLETO</span>
              </h2>
              <p className="text-white/85 mb-8" data-id="element-149">
                Todo lo que necesitas para iniciar tu reprogramación
                neuro-cuántica hoy mismo.
              </p>
              <ul className="space-y-4 mb-8" role="list" data-id="element-150">
                {includes.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-151">
                    <CheckCircle2Icon className="w-6 h-6 text-gold shrink-0" aria-hidden="true" data-id="element-152" />
                    <span className="text-white/95" data-id="element-153">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div ref={rightRef} className={`text-center bg-white/5 backdrop-blur-sm p-8 rounded-xl border border-white/10 will-animate animate-slideRight ${rightInView ? 'is-visible' : ''}`} data-id="element-154">
              <div className="mb-6" data-id="element-155">
                <span className="text-5xl font-black text-gold" aria-label="Precio 6 dólares con 39 centavos" data-id="element-156">
                  $6.39
                </span>
              </div>
              <p className="text-sm text-white/75 mb-8" data-id="element-157">
                Pago único. Sin suscripciones ocultas.
              </p>

              <button onClick={handlePurchase} className="bg-gold text-dark border-none py-4 px-6 text-base font-black rounded cursor-pointer transition-all duration-300 shadow-[0_10px_25px_rgba(212,175,55,0.3)] w-full hover:scale-[1.03] hover:bg-[#f1c40f]" data-id="element-158">
                DESCARGAR $6.39
              </button>

              <div className="mt-6 flex items-center justify-center gap-2 text-white/65 text-xs" data-id="element-159">
                <span aria-label="Compra 100% segura y encriptada" data-id="element-160">
                  🔒 Compra 100% Segura y Encriptada
                </span>
              </div>
            </div>
          </div>

          <p className="text-white/70 text-sm sm:text-base leading-relaxed mt-8 text-center max-w-2xl mx-auto italic" data-id="element-161">
            Este protocolo de programación neuro-cuántica está valorado en{' '}
            <span className="text-white/90 font-bold line-through" data-id="element-162">$97</span>,
            pero mi misión es reprogramar la mayor cantidad de mentes posible.
            Por eso, hoy accedes al{' '}
            <span className="text-gold font-bold" data-id="element-163">CÓDIGO 888</span> por solo{' '}
            <span className="text-gold font-black text-lg" data-id="element-164">$6.39</span>. Menos
            de lo que cuesta un café, para transformar tu realidad desde la
            raíz.
          </p>
        </div>
      </div>
    </section>;
}